export enum AuthUserType {
  SDG = 'sdg',
  CLIENT = 'client',
  UNKNOWN = 'unknown',
}
